import { POSTURE as posture } from './posture';
import { PROGRESS as progress } from './progress';
import { REWARD_STATUS as rewardStatus } from './rewardStatus';

export const SUMMARIES = { posture, progress, rewardStatus };
